import { render, staticRenderFns } from "./vueinfo.vue?vue&type=template&id=e062f708&scoped=true"
import script from "./vueinfo.vue?vue&type=script&lang=js"
export * from "./vueinfo.vue?vue&type=script&lang=js"
import style0 from "./vueinfo.vue?vue&type=style&index=0&id=e062f708&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e062f708",
  null
  
)

export default component.exports